<mat-tab-group
  #matTabGroup
  (selectedTabChange)="resetAllIframeLoaded()"
  [@.disabled]="true"
  [selectedIndex]="(wildlifeInfo || forestRoad ? 1 : 0) + getFeatureInfo.length"
  class="kilden3-feature-info-content mat-tab-fill-height">
  <mat-tab label="Koordinater">
    <div class="tab-content">
      <mat-list>
        @for (coordinate of coordinates; track coordinate) {
          <mat-list-item mat-list-item>
            <div mat-line>
              <b>{{ coordinate.name }}</b>
            </div>
            <div mat-line>{{ coordinate.value }}</div>
          </mat-list-item>
        }
      </mat-list>
    </div>
  </mat-tab>

  @if (wildlifeInfo) {
    <mat-tab [label]="wildlifeInfo.heading">
      @for (item of wildlifeInfo.features; track item) {
        <div class="wildlife">
          <h3>
            @if (item.mapSymbol?.shape) {
              <span
                [innerHTML]="item.mapSymbol | wildlifeLegend"
                class="symbol"
                title="Kartsymbol for {{ item.name }}"></span>
            }
            {{ item.name }}
          </h3>
          <table class="wildlife">
            @for (prop of item.properties; track prop) {
              <tr [class.time-row]="prop.label === 'Tidspunkt'">
                <td class="label">{{ prop.label }}:</td>
                <td>{{ prop.value }}</td>
              </tr>
            }
          </table>
        </div>
      }
    </mat-tab>
  }

  @if (forestRoad) {
    <mat-tab [label]="forestRoad.heading">
      <kilden3-forest-road-info [id]="forestRoad.id" />
    </mat-tab>
  }

  @for (feature of getFeatureInfo; track feature) {
    <mat-tab [label]="feature.name">
      @if (!feature.iframeLoaded) {
        <mat-spinner color="primary" diameter="50" value="50" strokeWidth="3" />
      }
      @if (feature.url && feature.url.length > 1) {
        <iframe
          (load)="feature.iframeLoaded = true"
          [src]="feature.url | safe: 'resourceUrl'"
          title="feature.name"
          width="100%"
          height="100%"
          frameborder="0"
          class="tab-content">
        </iframe>
      }
    </mat-tab>
  }

  @if (tabsLoading) {
    <mat-tab label="Henter data">
      <ng-template mat-tab-label>
        Henter
        <mat-spinner class="inline-spinner" color="primary" diameter="20" strokeWidth="2" value="50" />
      </ng-template>
    </mat-tab>
  }
</mat-tab-group>
